import { Component, ElementRef, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isObjectEqual } from 'app/shared/Utils/common.utils';

import { EditableComponent } from '../editable.types';
import { EditSelectModalComponent } from 'app/shared/modals/edit-custom-field-select/edit-custom-field-select.component';

@Component({
  templateUrl: './select-editable.component.html',
  styleUrls: ['./select-editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectEditableComponent extends EditableComponent implements OnInit {
  private _originalValue: string | string[];

  public options: any[];
  public value: string | string[];
  public editing: boolean = false;
  public userEditable: boolean = false;
  public multiple: boolean = false;
  public selectionChange: boolean = false;

  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  constructor(private _matDialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.getValue();

    this._originalValue = this.value;

    this.multiple = this.fieldDef.meta?.multi_select;

    if (this.multiple && this.value === null) this.value = [];

    if (!this.fieldDef.meta.option_name) {
      const options = this.fieldDef.meta?.options ?? [];
      this.options = options.map((value) => ({ id: value, name: value }));

      this.userEditable = this.fieldDef.meta.user_editable;
    } else {
      this.options = this.data.options[this.fieldDef.meta.option_name].filter((option) => !option.hidden);

      if (this.fieldDef.name === 'template_id') {
        this.options = this.options.filter((x) => x.related_to_type === this.fieldDef.related_to_type);
      }

      if (this.fieldDef.meta.option_name == 'pipelines') {
        this.options = this.options.filter((pipeline) => pipeline?.pipeline_type != 'dynamic');
      }

      this.options = this.options.filter((option) => {
        if (option.hidden) {
          return false;
        } else {
          if (option?.pipeline_ids) {
            if (this.model.pipeline_id) {
              return option?.pipeline_ids.includes(Number(this.model.pipeline_id));
            }
          }
        }
        return true;
      });

      if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
        this.readonly = this.fieldDef.meta.readonly;
      }
    }

    if (this.editMode) {
      this.editing = this.editMode;
    }
  }

  private onSave(): void {
    if (!isObjectEqual(this._originalValue, this.value) && this.value !== 'add_new') {
      this.updateModel();
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
    this.update.emit({ [this.fieldDef.name]: this.value });
  }

  private processChanges(): void {
    if (this.value === 'add_new') {
      this.enrichCustomField();
      const dialogRef = this._matDialog.open(EditSelectModalComponent, {
        panelClass: 'mailbox-compose-dialog',
        data: this.fieldDef,
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.update.emit({ [this.fieldDef.name]: this.value });
      });
    } else {
      this.onSave();
      this.editing = false;
      this.onEndEditing.emit();
    }
  }

  private enrichCustomField(): void {
    this.fieldDef.calc_code = this.fieldDef.meta.calc_code;
    this.fieldDef.options = this.fieldDef.meta.options;
  }

  edit(): void {
    if (!this.editing && !this.isDisabled) {
      this.editing = true;
    }
  }

  onSelectionChange(): void {
    if (this.multiple) this.selectionChange = true;
    else this.processChanges();
  }

  openedChange(isOpening: boolean): void {
    if (this.selectionChange && !isOpening) this.processChanges();

    if (!isOpening) {
      this.editing = false;
      this.onEndEditing.emit();
    }
  }

  onBlur(): void {
    this.onSave();
    if (!this.multiple) {
      this.editing = false;
      this.onEndEditing.emit();
    }
  }

  nestedFieldArrayValue(value: string): string[] {
    if (value) {
      try {
        return JSON.parse(value);
      } catch (error) {
        console.error('Error parsing nested field array value:', error);
      }
    }
    return [];
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
}
